import { z } from "zod"

export const BillingLocationSchema = z.object({
  locationId: z.string().min(1, "Location is required"),
})

export type BillingLocationFormValues = z.infer<typeof BillingLocationSchema>
